import { MutableRefObject, useRef } from 'react';

import { NwApplicationServiceTypes } from '../../services/NwApplicationServices/APIService';
import { NwApplicationService } from '../../services/NwApplicationServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

interface NwApplicationServiceInstance {
  nwApplicationService: NwApplicationServiceTypes;
}

const useNwApplicationService = (): NwApplicationServiceInstance => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();

  const NwApplicationServiceRef: MutableRefObject<NwApplicationServiceTypes | null> =
    useRef(null);

  if (NwApplicationServiceRef.current === null) {
    NwApplicationServiceRef.current = new NwApplicationService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    nwApplicationService: NwApplicationServiceRef.current
  };
};

export { useNwApplicationService };
